import { FeatureFlag } from '../FeatureFlag';

export const useRustAssistant = new FeatureFlag({
    key: 'use-rust-assistant',
    defaultValue: false,
});
